import { InfoIcon } from "../../../atoms/icons/info-i";
import React from "react";

export const InfoText = ({ tip = "none provided" }) => {
  return (
    <div className="irq-right-side-content">
      <div className="flex-row align-items-center border-bottom">
        <InfoIcon className="margin-right" fill="white" />
        <div className="bold">Learn</div>
      </div>
      <div>{tip}</div>
    </div>
  );
};
